/* La Table des Cimes — animations v4 « relief » */
(function(){
  var root=document.documentElement;
  if(!root.classList.contains('tdc-anim'))return;
  window.tdcReady=true;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function go(){root.classList.add('tdc-go');}
  if(reduce){go();return;}
  var fine=window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches;
  var W=innerWidth,H=innerHeight;
  function $(s,c){return (c||document).querySelector(s);}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function clamp(v,a,b){return v<a?a:v>b?b:v;}

  /* =========================================================
     1. INTRO (déjà dans la page, uniquement sur l'accueil)
     ========================================================= */
  var introEl=$('.tdc-intro');
  var INTRO_MS=2600;
  /* rechargement : on repart du haut de la page (sinon on atterrit au milieu sous l'intro) */
  if(introEl&&!location.hash){try{history.scrollRestoration='manual';}catch(e){}window.scrollTo(0,0);}
  function intro(done){
    var finished=false;
    function end(){
      if(finished)return;finished=true;
      introEl.classList.add('out');done();
      setTimeout(function(){if(introEl&&introEl.parentNode)introEl.parentNode.removeChild(introEl);},1200);
    }
    /* première visite de la session (et son non coupé) : on attend « Entrer »,
       ce geste lance l'ambiance du feu ; sinon l'intro se ferme seule */
    var gate=false;
    try{gate=!sessionStorage.getItem('tdc-in')&&localStorage.getItem('tdc-snd')!=='off';}catch(e){gate=false;}
    if(gate&&introEl.querySelector('.tdc-enter')){
      introEl.classList.add('tdc-gate');
      var mute=introEl.querySelector('.tdc-enter__mute');
      if(mute)mute.addEventListener('click',function(e){e.stopPropagation();try{localStorage.setItem('tdc-snd','off');}catch(x){}document.dispatchEvent(new CustomEvent('tdc:mute'));end();});
      introEl.addEventListener('click',end);
      /* touche, molette ou glissement : on entre aussi (le son démarrera au premier clic) */
      var keyEnd=function(e){if(finished)return;if(e.key==='Enter'||e.key===' '||e.key==='Escape'||e.key==='ArrowDown'){e.preventDefault();end();}};
      document.addEventListener('keydown',keyEnd);
      window.addEventListener('wheel',end,{passive:true,once:true});
      window.addEventListener('touchmove',end,{passive:true,once:true});
      /* sécurité : l'intro ne reste jamais bloquée */
      setTimeout(end,9000);
      try{sessionStorage.setItem('tdc-in','1');}catch(e){}
      return;
    }
    var elapsed=(window.performance&&performance.now)?performance.now():0;
    setTimeout(end,Math.max(0,INTRO_MS-elapsed));
    introEl.addEventListener('click',end);
  }

  /* =========================================================
     2. DÉCOUPAGES DE TEXTE
     ========================================================= */
  var h1=$('.hero__h1');
  if(h1){
    var parts=h1.innerHTML.split(/<br\s*\/?>/i),k=0;
    h1.innerHTML=parts.map(function(line){
      return line.trim().split(/\s+/).map(function(w){
        var d=(0.25+k++*0.11).toFixed(2);
        return '<span class="tdc-w"><span style="transition-delay:'+d+'s">'+w+'</span></span>';
      }).join(' ');
    }).join('<br>');
  }

  /* Le menu s'écrit */
  function splitChars(el,start,speed){
    var txt=el.textContent,out='',t=start;
    for(var i=0;i<txt.length;i++){
      var c=txt[i]===' '?' ':txt[i].replace('&','&amp;').replace('<','&lt;');
      out+='<span class="tdc-c" style="--d:'+t+'">'+c+'</span>';t+=speed;
    }
    el.innerHTML=out+'<span class="tdc-caret" style="--d:'+start+'"></span>';
    el.classList.add('tdc-type');el.dataset.end=t;return t;
  }
  function splitWords(el,start,speed){
    var ws=el.textContent.trim().split(/\s+/),t=start;
    el.innerHTML=ws.map(function(w){var s='<span class="tdc-wd" style="--d:'+t+'">'+w+'</span>';t+=speed;return s;}).join(' ');
    el.classList.add('tdc-desc');return t;
  }
  var typed=[];
  $$('.mcard').forEach(function(card,ci){
    var t=350;
    var head=$('.mcard__head h3',card);
    if(head){t=splitChars(head,t,30)+100;typed.push({el:head,card:card});}
    $$('.mcard__list li',card).forEach(function(li){
      var num=$('.mcard__num',li),tag=$('.mcard__tag',li),h4=$('h4',li),p=$('p',li);
      if(num){num.classList.add('tdc-num');num.style.setProperty('--d',t);}
      if(tag){tag.classList.add('tdc-desc');tag.innerHTML='<span class="tdc-wd" style="--d:'+t+'">'+tag.innerHTML+'</span>';}
      if(h4){t=splitChars(h4,t+60,15)+40;typed.push({el:h4,card:card});}
      if(p){t=splitWords(p,t,14)+100;}
    });
    card.dataset.rv=ci%2?'flipR':'flipL';
  });

  /* Titres de section : mots en 3D (seulement si texte simple) */
  $$('main section:not(.hero) h2').forEach(function(h){
    h.classList.add('tdc-h2');
    if(h.children.length)return;
    var ws=h.textContent.trim().split(/\s+/);
    h.innerHTML=ws.map(function(w,i){return '<span class="tdc-tw"><span style="--w:'+i+'">'+w+'</span></span>';}).join(' ');
    h.dataset.rv='title';
  });

  /* =========================================================
     3. ÉLÉMENTS À RÉVÉLER
     ========================================================= */
  function mark(sel,type){$$(sel).forEach(function(el){if(el.closest('.hero')||el.closest('.mcard__list')||el.closest('.mq')||el.hasAttribute('data-rv'))return;el.dataset.rv=type||'up';});}
  mark('main section:not(.hero) .ew','fade');
  mark('main section:not(.hero) h2');
  mark('main section:not(.hero) h2 + p, .carte__sub, .gallery__sub, .faq__intro, .ledger__sub, .ledger__badge, .contact__sub, .rv__score, .steps__intro, .frm__sub','fade');
  mark('.carte__price','zoom');
  mark('.about__txt p, .about__quote','left');
  mark('.about__photo','zoom');
  mark('.gi');
  mark('.frm__card, .step','card');
  mark('.rv__card','deck');
  mark('.ledger__book, .contact-frm','zoom');
  mark('.faq__item, .cinfo, .faq__cta, .rv__cta, .steps__cta, .frm__cta','fade');
  mark('main section:not(.hero) li, main section:not(.hero) article');
  mark('main section:not(.hero) .btn','fade');
  mark('.ml__wrap h1, .gc__card','zoom');
  mark('.gc__body > *','fade');
  $$('[data-rv]').forEach(function(el){
    var sibs=Array.prototype.filter.call(el.parentNode.children,function(c){return c.hasAttribute('data-rv');});
    el.style.setProperty('--i',Math.min(sibs.indexOf(el),6));
  });

  function reveal(el){
    if(el.classList.contains('in'))return;
    el.classList.add('in');
    if(el.classList.contains('mcard')&&!el.classList.contains('mcard--flip'))typeCard(el);
    var i=+(el.style.getPropertyValue('--i')||0);
    setTimeout(function(){el.classList.add('tdc-done');},1500+i*120);
  }
  function typeCard(card){
    if(card._typed)return;card._typed=true;
    $$('.tdc-type,.tdc-desc,.tdc-num',card).forEach(function(x){x.classList.add('in');});
    typed.forEach(function(o){if(o.card===card){setTimeout(function(){o.el.classList.add('done');},+o.el.dataset.end+200);}});
  }
  /* menus qui se retournent : le menu s'écrit au premier retournement */
  $$('.mcard').forEach(function(c){c.addEventListener('tdc:flip',function(){typeCard(c);});});
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){if(en.isIntersecting){var t=en.target;if(t._rvKids)t._rvKids.forEach(reveal);else reveal(t);io.unobserve(t);}});
  },{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  /* photos de la galerie : elles sont masquées par un rideau (clip-path), que les navigateurs
     comptent comme « invisible » -> on surveille la grille qui les contient, pas les photos */
  function observe(){$$('[data-rv]').forEach(function(el){
    if(el.classList.contains('gi')&&el.parentNode){var p=el.parentNode;if(!p._rvKids){p._rvKids=[];io.observe(p);}p._rvKids.push(el);return;}
    io.observe(el);
  });}

  /* =========================================================
     4. ACCESSOIRES : progression, curseur, en-tête
     ========================================================= */
  var prog=document.createElement('div');prog.className='tdc-prog';document.body.appendChild(prog);
  var hdr=$('.hdr');

  var cur,dot,cx=W/2,cy=H/2,tx=cx,ty=cy,curOn=false;
  if(fine){
    cur=document.createElement('div');cur.className='tdc-cur';
    dot=document.createElement('div');dot.className='tdc-dot';
    document.body.appendChild(cur);document.body.appendChild(dot);
    document.addEventListener('mouseover',function(e){
      var t=e.target;
      var big=t.closest&&t.closest('a,button,label,summary,.cd,.tdc-tilt,select');
      var txt=t.closest&&t.closest('input,textarea');
      cur.classList.toggle('big',!!big&&!txt);
      cur.classList.toggle('txt',!!txt);
    });
    document.addEventListener('mouseleave',function(){cur.classList.remove('on');dot.classList.remove('on');curOn=false;});
  }

  /* =========================================================
     5. INCLINAISON 3D DES CARTES (souris)
     ========================================================= */
  var tilts=[];
  if(fine){
    $$('.mcard, .frm__card, .rv__card, .gi, .gc__card, .step').forEach(function(el){
      if(el.closest('.gal-h'))return;
      el.classList.add('tdc-tilt');
      var g=document.createElement('span');g.className='tdc-glare';el.appendChild(g);
      var max=el.classList.contains('mcard')?6:el.classList.contains('gc__card')?14:9;
      var o={el:el,rx:0,ry:0,s:0,trx:0,try_:0,ts:0,max:max,hover:false,active:false};
      tilts.push(o);
      el.addEventListener('mouseenter',function(){o.hover=true;});
      el.addEventListener('mouseleave',function(){o.hover=false;o.trx=0;o.try_=0;o.ts=0;});
      el.addEventListener('mousemove',function(e){
        var r=el.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
        o.try_=(px-.5)*2*o.max;o.trx=-(py-.5)*2*o.max;o.ts=1;
        el.style.setProperty('--gx',(px*100).toFixed(1)+'%');el.style.setProperty('--gy',(py*100).toFixed(1)+'%');
        kick();
      });
    });
    var gcc=$('.gc__card');if(gcc)gcc.classList.add('tdc-float');
  }

  /* Boutons magnétiques */
  var mags=[];
  if(fine){
    $$('.btn, .hdr__cta, .wa-btn').forEach(function(el){
      el.classList.add('tdc-mag');
      el.addEventListener('mousemove',function(e){
        var r=el.getBoundingClientRect();
        var dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2);
        el.classList.add('is-mag');
        el.style.translate=clamp(dx*.22,-10,10).toFixed(1)+'px '+clamp(dy*.32,-8,8).toFixed(1)+'px';
      });
      el.addEventListener('mouseleave',function(){el.classList.remove('is-mag');el.style.translate='0px 0px';});
    });
  }

  /* =========================================================
     6. SCÈNES PILOTÉES PAR LE DÉFILEMENT
     ========================================================= */
  var hero=$('.hero'),heroBg=$('.hero__bg'),heroBox=$('.hero__box'),glow=$('.hero__glow');
  /* le hero remplit exactement l'écran sous l'en-tête : les montagnes sont visibles dès l'arrivée */
  function fitHero(){
    if(!hero)return;
    var top=hero.getBoundingClientRect().top+scrollY;
    hero.style.minHeight=Math.max(520,innerHeight-top)+'px';
  }
  fitHero();
  var ridges=$$('.hero__ridge');
  var heroLive=false;
  var gis=$$('.gi'),galGrid=$('.gallery__grid'),aboutPh=$('.about__photo'),aboutImg=aboutPh&&$('img',aboutPh);
  var steps=$('.steps__grid'),sline=null,stepNs=$$('.step__n');
  if(steps){sline=document.createElement('span');sline.className='tdc-sline';steps.insertBefore(sline,steps.firstChild);}
  var mq=$('.mq__track');
  if(mq)root.classList.add('tdc-js-mq');

  var vis={hero:true,mq:false,gal:false,about:false,steps:false};
  var vio=new IntersectionObserver(function(es){es.forEach(function(e){vis[e.target.dataset.tdcv]=e.isIntersecting;});kick();},{rootMargin:'120px 0px'});
  function watch(el,key){if(el){el.dataset.tdcv=key;vio.observe(el);}}
  watch(hero,'hero');watch($('.mq'),'mq');watch($('.gallery'),'gal');watch(aboutPh,'about');watch(steps,'steps');

  var mx=0,my=0,tmx=0,tmy=0;      /* souris normalisée -1..1 */
  var sy=scrollY,ssy=scrollY,vel=0,mqX=0,lastT=0,running=false,idle=0;
  window.addEventListener('mousemove',function(e){
    tmx=e.clientX/W*2-1;tmy=e.clientY/H*2-1;
    tx=e.clientX;ty=e.clientY;
    if(cur&&!curOn){curOn=true;cx=tx;cy=ty;cur.classList.add('on');dot.classList.add('on');}
    kick();
  },{passive:true});
  var lastSY=scrollY,hdrHidden=false;
  window.addEventListener('scroll',function(){
    var y=scrollY;
    if(hdr){
      var down=y>lastSY;
      if(y>innerHeight*.9&&down&&Math.abs(y-lastSY)>3&&!hdrHidden){hdr.classList.add('hdr--up');hdrHidden=true;}
      else if((!down&&Math.abs(y-lastSY)>3||y<innerHeight*.5)&&hdrHidden){hdr.classList.remove('hdr--up');hdrHidden=false;}
    }
    lastSY=y;kick();
  },{passive:true});
  window.addEventListener('resize',function(){var wc=innerWidth!==W;W=innerWidth;H=innerHeight;if(wc)fitHero();sizeSnow();measure();kick();});

  function kick(){idle=0;if(!running){running=true;lastT=0;requestAnimationFrame(frame);}}

  var maxScroll=0,mqHalf=0;
  function measure(){maxScroll=document.documentElement.scrollHeight-innerHeight;mqHalf=mq?mq.scrollWidth/2:0;}
  measure();
  if(window.ResizeObserver){try{new ResizeObserver(function(){measure();}).observe(document.body);}catch(e){}}
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(measure);
  function frame(t){
    var dt=lastT?Math.min(64,t-lastT):16.7;lastT=t;
    /* lectures de mise en page AVANT toute écriture (évite les recalculs forcés à chaque image) */
    var rg=(vis.gal&&galGrid&&!galGrid.closest('.gal-h'))?galGrid.getBoundingClientRect():null;
    var ra=(vis.about&&aboutImg)?aboutPh.getBoundingClientRect():null;
    var rs=(vis.steps&&sline)?steps.getBoundingClientRect():null;
    var hh=(hero&&vis.hero&&heroLive)?(hero.offsetHeight||H):H;
    var f=1-Math.pow(1-.075,dt/16.7);   /* lissage indépendant de la fréquence */
    var settled=true;

    /* défilement lissé + vitesse */
    sy=scrollY;var psy=ssy;ssy+=(sy-ssy)*f;
    var v=(ssy-psy)/dt*16.7;vel+=(v-vel)*.12;
    if(Math.abs(sy-ssy)>.3)settled=false;

    /* progression */
    var max=maxScroll;
    prog.style.transform='scaleX('+(max>0?clamp(sy/max,0,1):0).toFixed(4)+')';

    /* souris (sur tactile : légère dérive automatique) */
    if(!fine&&vis.hero){tmx=Math.sin(t*.00028)*.35;tmy=Math.cos(t*.00021)*.2;}
    mx+=(tmx-mx)*f;my+=(tmy-my)*f;
    if(Math.abs(tmx-mx)>.001||Math.abs(tmy-my)>.001)settled=false;

    /* curseur */
    if(cur&&curOn){
      cx+=(tx-cx)*Math.min(1,f*2.2);cy+=(ty-cy)*Math.min(1,f*2.2);
      cur.style.transform='translate3d('+cx.toFixed(1)+'px,'+cy.toFixed(1)+'px,0)';
      dot.style.transform='translate3d('+tx+'px,'+ty+'px,0)';
      if(Math.abs(tx-cx)>.2||Math.abs(ty-cy)>.2)settled=false;
    }

    /* HERO : profondeur souris + plongée au défilement */
    if(hero&&vis.hero&&heroLive){
      var p=clamp(ssy/hh,0,1);
      if(heroBg)heroBg.style.transform='translate3d('+(-mx*22).toFixed(2)+'px,'+(-my*14+p*hh*.32).toFixed(2)+'px,0) scale('+(1.06+p*.12).toFixed(4)+')';
      if(glow)glow.style.transform='translate3d('+((mx*.5+.5)*W).toFixed(1)+'px,'+((my*.5+.5)*H*.9+p*hh*.2).toFixed(1)+'px,0)';
      var depth=[[12,.38],[26,.18],[42,0]];
      ridges.forEach(function(r,i){r.style.transform='translate3d('+(-mx*depth[i][0]).toFixed(2)+'px,'+(p*hh*depth[i][1]).toFixed(2)+'px,0)';});
      if(heroBox){
        heroBox.style.transform='translate3d(0,'+(-p*hh*.12).toFixed(2)+'px,'+(-p*320).toFixed(1)+'px) rotateX('+(my*-3+p*14).toFixed(3)+'deg) rotateY('+(mx*4).toFixed(3)+'deg)';
        heroBox.style.opacity=clamp(1-p*1.5,0,1).toFixed(3);
      }
    }

    /* GALERIE : courbure en perspective + parallaxe des photos */
    if(vis.gal){
      if(rg){
        var cg=clamp(((rg.top+rg.height/2)-H/2)/(H*.8),-1.2,1.2);
        galGrid.style.transform='perspective(1600px) rotateX('+(cg*-10).toFixed(3)+'deg) scale('+(1-Math.abs(cg)*.04).toFixed(4)+')';
        gis.forEach(function(g){g.style.setProperty('--py',(cg*-30).toFixed(2)+'px');});
      }
    }

    /* LE CHEF : parallaxe de la photo */
    if(ra){
      var ca=clamp(((ra.top+ra.height/2)-H/2)/H,-1,1);
      aboutPh.style.setProperty('--py',(ca*-46).toFixed(2)+'px');
    }

    /* DÉROULEMENT : le fil doré se dessine */
    if(rs){
      var ps=clamp((H*.82-rs.top)/(rs.height*.9),0,1);
      sline.style.transform='scaleX('+ps.toFixed(4)+')';
      stepNs.forEach(function(n,i){
        var on=ps>(i/stepNs.length)+.04;
        if(n._on!==on){n._on=on;n.style.transition='transform .9s cubic-bezier(.16,1,.3,1),color .6s';n.style.transform=on?'perspective(300px) rotateY(0deg) scale(1)':'perspective(300px) rotateY(-70deg) scale(.85)';n.style.color=on?'#D9A84E':'';}
      });
    }

    /* BANDEAU : vitesse + inclinaison selon le défilement */
    if(mq&&vis.mq){
      mqX-=(0.45+Math.abs(vel)*.6)*dt/16.7*(vel<-0.5?-1:1);
      var half=mqHalf;
      if(half>0){if(mqX<=-half)mqX+=half;if(mqX>0)mqX-=half;}
      mq.style.transform='translate3d('+mqX.toFixed(2)+'px,0,0) skewX('+clamp(-vel*.35,-12,12).toFixed(2)+'deg)';
      settled=false;
    }

    /* CARTES : inclinaison (combinée à la courbure de la galerie) */
    tilts.forEach(function(o){
      if(!o.el.classList.contains('tdc-done'))return;
      var trx=o.trx;
      o.rx+=(trx-o.rx)*f*1.4;o.ry+=(o.try_-o.ry)*f*1.4;o.s+=(o.ts-o.s)*f;
      var moving=Math.abs(trx-o.rx)>.01||Math.abs(o.try_-o.ry)>.01||Math.abs(o.ts-o.s)>.002;
      if(moving)settled=false;
      var on=o.hover||Math.abs(o.rx)>.02||Math.abs(o.ry)>.02;
      if(on){
        if(!o.active){o.active=true;o.el.style.transition='opacity .9s ease';}
        o.el.style.transform='perspective(1000px) rotateX('+o.rx.toFixed(3)+'deg) rotateY('+o.ry.toFixed(3)+'deg) translateZ('+(o.s*14).toFixed(2)+'px)';
      }else if(o.active){
        o.active=false;o.el.style.transform='';o.el.style.transition='';
      }
      o.el.classList.toggle('is-tilt',o.hover);
    });

    /* neige */
    if(snow&&vis.hero){drawSnow(dt);settled=false;}

    if(settled){idle+=dt;}else idle=0;
    if(idle>400){running=false;return;}
    requestAnimationFrame(frame);
  }

  /* =========================================================
     7. NEIGE EN PROFONDEUR (canvas, sans librairie)
     ========================================================= */
  var snow=$('.hero__snow'),sctx=null,flakes=[],dpr=1;
  function sizeSnow(){
    if(!snow||!sctx)return;
    dpr=Math.min(window.devicePixelRatio||1,1.25);
    var r=snow.getBoundingClientRect();
    snow.width=Math.round(r.width*dpr);snow.height=Math.round(r.height*dpr);
    var n=Math.round(clamp(r.width*r.height/12000,30,120));
    while(flakes.length<n)flakes.push(newFlake(true));
    flakes.length=n;
  }
  function newFlake(any){
    var z=Math.pow(Math.random(),1.6);              /* 0 = loin, 1 = proche */
    return {x:Math.random(),y:any?Math.random():-.05,z:z,ph:Math.random()*6.28,sp:.6+Math.random()*.8,
            gold:Math.random()<.12};
  }
  function drawSnow(dt){
    var w=snow.width,h=snow.height;
    sctx.clearRect(0,0,w,h);
    var hh=hero.offsetHeight||H,p=clamp(ssy/hh,0,1);
    for(var i=0;i<flakes.length;i++){
      var fl=flakes[i],z=fl.z;
      fl.ph+=.012*dt/16.7;
      fl.y+=(.00018+z*.0011)*fl.sp*dt/16.7;
      fl.x+=Math.sin(fl.ph)*.00025*(1+z)*dt/16.7;
      if(fl.y>1.04){flakes[i]=newFlake(false);continue;}
      if(fl.x<-.05)fl.x+=1.1;if(fl.x>1.05)fl.x-=1.1;
      var px=(fl.x*w)+(-mx*(8+z*60))*dpr;
      var py=(fl.y*h)+(-my*(4+z*30)-p*z*hh*.6)*dpr;
      var r=(.6+z*2.6)*dpr;
      var a=(.18+z*.62)*(1-p*.6);
      if(fl.gold){
        var gr=r*3.2;
        var g=sctx.createRadialGradient(px,py,0,px,py,gr);
        g.addColorStop(0,'rgba(217,168,78,'+(a*.55).toFixed(3)+')');g.addColorStop(1,'rgba(217,168,78,0)');
        sctx.fillStyle=g;sctx.beginPath();sctx.arc(px,py,gr,0,6.283);sctx.fill();
      }else{
        sctx.fillStyle='rgba(245,241,232,'+a.toFixed(3)+')';
        sctx.beginPath();sctx.arc(px,py,r,0,6.283);sctx.fill();
      }
    }
  }
  if(snow&&snow.getContext){sctx=snow.getContext('2d');sizeSnow();}else{snow=null;}

  /* =========================================================
     8. LANCEMENT
     ========================================================= */
  function start(){
    go();
    setTimeout(observe,introEl?450:0);
    /* une fois l'entrée du hero terminée, la scène 3D prend la main */
    setTimeout(function(){heroLive=true;root.classList.add('tdc-live');kick();},2700);
    kick();
  }
  if(introEl){intro(start);}else{requestAnimationFrame(function(){requestAnimationFrame(start);});}
  window.addEventListener('pageshow',function(e){if(e.persisted){go();$$('[data-rv]').forEach(reveal);}});
  /* sécurité */
  setTimeout(function(){if(introEl&&introEl.classList.contains('tdc-gate')&&!introEl.classList.contains('out'))return;go();$$('[data-rv]:not(.in)').forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight)reveal(el);});},5500);
  /* éléments dépassés sans être vus (saut via un lien d'ancre) */
  /* + filet de sécurité : tout ce qui est à l'écran ou déjà dépassé s'affiche (vérifié au plus toutes les 0,4 s) */
  var skipTk=false,skipY=scrollY,skipT=0;
  window.addEventListener('scroll',function(){
    var now=Date.now(),jump=Math.abs(scrollY-skipY)>innerHeight*.8;skipY=scrollY;
    if(skipTk||(!jump&&now-skipT<400))return;skipTk=true;skipT=now;
    requestAnimationFrame(function(){skipTk=false;$$('[data-rv]:not(.in)').forEach(function(el){if(el.getBoundingClientRect().top<innerHeight*.92)reveal(el);});});
  },{passive:true});
})();
